<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form v-if="value" action>
      <div class="modal-card" style="width: 800px">
        <!-- ヘッダ -->
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke; text-align: left">テンプレート管理</p>
        </header>

        <!-- セクション -->
        <section class="modal-card-body" style="width: 100%; text-align: left">
          <div class="columns">
            <div class="column">
              <b-button
                class="button is-primary has-text-centered"
                native-type="button"
                @click="showSupportContentsTemplate()"
              >追加</b-button>
            </div>

            <div class="column">
              <b-field horizontal label="テンプレート数" style="float: right; white-space: nowrap">
                <b-select position="is-right" v-model="perPage">
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </b-select>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column is-full">
              <b-table
                :data="data"
                :paginated="isPaginated"
                :per-page="perPage"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :pagination-size="paginationSize"
                :default-sort-direction="defaultSortDirection"
                default-sort="categoryId"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
              >
                <template slot-scope="props">
                  <b-table-column field="categoryId" label="No" sortable centered>{{ props.row.id }}</b-table-column>

                  <b-table-column
                    v-if="showSalseOffice"
                    field="salesOffice"
                    label="営業所"
                    sortable
                  >{{ props.row.salesOffice }}</b-table-column>

                  <b-table-column
                    field="templateName"
                    label="テンプレート名"
                    sortable
                  >{{ props.row.templateName }}</b-table-column>

                  <b-table-column label="編集" centered>
                    <b-button
                      class="button is-primary has-text-centered"
                      icon-left="checkbox-multiple-blank-outline"
                      native-type="button"
                      @click="showSupportContentsTemplate(props.row)"
                    ></b-button>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </section>

        <!-- フッタ -->
        <footer class="modal-card-foot">
          <b-button class="button" type="button" @click="close()">閉じる</b-button>
        </footer>
      </div>
    </form>

    <support-contents-template
      v-model="isShowSupportContentsTemplate"
      :template="editTemplate"
      @closed="loadTemplates()"
    />
  </b-modal>
</template>

<script>
import AppSupportContentsTemplate from "./AppSupportContentsTemplate";

export default {
  name: "AppSupportCategory",
  props: {
    value: { type: Boolean, default: false }
  },

  computed: {
    showSalseOffice: function() {
      const showSalseOffice = this.userInfo.roleId == 1 || this.userInfo.roleId == 2 || this.userInfo.referenceOfficeCodes.length > 1;
      return showSalseOffice;
    },
  },

  methods: {
    close: function() {
      this.$emit("input", false);
      return;
    },

    // テンプレート登録ダイアログ表示
    showSupportContentsTemplate: function(tenplate) {
      this.editTemplate = tenplate;
      this.isShowSupportContentsTemplate = true;
      return;
    },

    // テンプレート一覧取得
    loadTemplates: function() {
      this.apiCall(
        this.getPatientSupportHistoryTemplatesGET,
        this.getPatientSupportHistoryTemplatesGETsuccess,
        this.webApiError
      );

      return;
    },

    // テンプレート一覧取得
    getPatientSupportHistoryTemplatesGET: function(client) {
      const apiRes = client.apis.apiPatientSupport.getPatientSupportHistoryTemplatesGET(
        {
          mode: "admin",
          officeCode: this.userInfo.officeCode
        }
      );
      return apiRes;
    },

    // テンプレート一覧取得成功
    getPatientSupportHistoryTemplatesGETsuccess: function(result) {
      for (const template of result.obj) {
        const salesOffice = this.officeMaster.find(
          elem => elem.officeCode == template.salesOfficeCode
        );
        // ソート向け編集
        template.salesOffice = salesOffice ? salesOffice.officeName : " ";
      }
      this.data = result.obj;
      return;
    },

    // Web APIエラー
    webApiError: function(result) {
      this.showErrorMessage(result);
      return;
    }
  },

  created: function() {
    // ユーザー情報取得
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userInfo = userInfo;

    // 営業所マスタ取得
    const officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    this.officeMaster = officeMaster;

    return;
  },

  mounted: function() {
    return;
  },

  data() {
    return {
      data: [],
      userInfo: {
        referenceOfficeCodes: [],
      },
      officeMaster: null,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      isShowSupportContentsTemplate: false,
      editTemplate: null
    };
  },

  watch: {
    value: function() {
      if (this.value) {
        // テンプレート一覧取得
        this.loadTemplates();
      }
      return;
    }
  },

  components: {
    "support-contents-template": AppSupportContentsTemplate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppSupportContentsTemplateAdmin.vue